/* eslint-disable import/no-unresolved, import/no-webpack-loader-syntax */
import data from '!!../../config/editorial-loader.js!./sources.editorial.js';

export default data;
